/**
 * Theme styles for ::use syntax — header, close, block lines,
 * L0 pretty widget, L2 mark decorations.
 */

import { EditorView } from "@codemirror/view";
import {
    CM_MONO_FONT_FAMILY,
    accentIconStyles,
    accentMutedColor,
    accentText,
    directiveLineStyles,
    directivePrettyStyles,
} from "../shared/theme-helpers";

const USE_ACCENT = "--cm-use-accent";

export const useTheme = EditorView.baseTheme({
    /* L2: Use block header */
    ".cm-magic-use-head": {
        color: `var(${USE_ACCENT})`,
        fontWeight: "500",
        letterSpacing: "0.02em",
    },
    /* L2: Use block close */
    ".cm-magic-use-close": {
        color: `var(${USE_ACCENT})`,
        fontWeight: "500",
        opacity: "0.7",
    },
    /* Background for all lines within a use block */
    ".cm-magic-use-line": directiveLineStyles(USE_ACCENT, 6, 30),
    ".cm-magic-use-active .cm-magic-btn-group": {
        opacity: "1",
        maxWidth: "120px",
        pointerEvents: "auto",
    },
    /* L0: Pretty use widget */
    ".cm-magic-use-pretty": directivePrettyStyles(USE_ACCENT),
    ".cm-magic-use-pretty-icon": accentIconStyles(USE_ACCENT),
    ".cm-magic-use-pretty-id": accentText(USE_ACCENT, {
        fontWeight: "600",
        letterSpacing: "0.01em",
    }),
    ".cm-magic-use-pretty-arrow": {
        color: accentMutedColor(USE_ACCENT, 60),
        fontSize: "12px",
    },
    ".cm-magic-use-pretty-source": {
        color: `var(${USE_ACCENT})`,
        fontWeight: "500",
        fontFamily: CM_MONO_FONT_FAMILY,
        fontSize: "12px",
    },
    ".cm-magic-use-pretty-plugin": {
        color: "var(--color-muted-foreground)",
        fontFamily: CM_MONO_FONT_FAMILY,
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "1.2",
        maxWidth: "180px",
        opacity: "0.76",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    ".cm-magic-use-pretty-template": {
        color: "var(--color-muted-foreground)",
        fontFamily: CM_MONO_FONT_FAMILY,
        fontSize: "11px",
        opacity: "0.68",
    },
});
